import { spring } from '@/utils/animations/commom';
import { getChipDom, getSlotDom } from '@/utils/questions/dnd/dndNodes';
import { playFlip } from '@/utils/questions/dnd/playFlip';
import { useLayoutEffect, useRef } from 'react';

type PreviousState = { occupant?: string; width: number };

const freezeChipWidth = (occupantId?: string) => {
  const chip = occupantId ? getChipDom(occupantId) : null;
  if (!chip) return () => undefined;

  chip.style.width = `${chip.getBoundingClientRect().width}px`;
  chip.style.flexShrink = '0';
  return () => {
    chip.style.width = '';
    chip.style.flexShrink = '';
  };
};

export function useSlotResizeFlip(
  slotId: string,
  occupantId?: string,
  occupantFlying?: boolean,
) {
  const previousRef = useRef<PreviousState>();

  useLayoutEffect(() => {
    const node = getSlotDom(slotId);
    if (!node) return;

    const width = node.getBoundingClientRect().width;
    const previous = previousRef.current;
    previousRef.current = { occupant: occupantId, width };

    if (!previous || previous.occupant === occupantId) return;
    if (occupantFlying) return;

    const from = previous.width;
    if (Math.abs(width - from) < 1) return;

    node.style.overflow = 'hidden';
    node.style.minWidth = '0';
    const unfreezeChip = freezeChipWidth(occupantId);
    return playFlip({
      node,
      keyframes: { width: [from, width] },
      options: spring,
      onSettle: settled => {
        settled.style.width = '';
        settled.style.overflow = '';
        settled.style.minWidth = '';
        unfreezeChip();
      },
    });
  }, [slotId, occupantId, occupantFlying]);
}
